import { useWatch } from 'react-hook-form';
var useDiscountInputHandlers = function (form, customerType) {
    var _a;
    var discountType = useWatch({
        control: form.control,
        name: "discountTypeFor".concat(customerType, "Customer"),
    });
    var error = (_a = form.formState.errors["discountValueFor".concat(customerType, "Customer")]) === null || _a === void 0 ? void 0 : _a.message;
    var onDiscountTypeChange = function () {
        form.setValue("discountValueFor".concat(customerType, "Customer"), null);
    };
    return {
        discountType: discountType,
        onDiscountTypeChange: onDiscountTypeChange,
        error: error,
    };
};
export var useDiscountHandlers = function (form) {
    var newCustomerDiscountHandlers = useDiscountInputHandlers(form, 'New');
    var existingCustomerDiscountHandlers = useDiscountInputHandlers(form, 'Existing');
    return {
        new: newCustomerDiscountHandlers,
        existing: existingCustomerDiscountHandlers,
    };
};
